import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';

@Component({
  selector: 'app-legal',
  templateUrl: './legal.component.html',
  styleUrls: ['./legal.component.scss']
})
export class LegalComponent implements OnInit {
  websiteBaseUrl: string;
  showAllPAIADocuments = false;

  constructor(private location: Location, private router: Router) {
    this.websiteBaseUrl = this.router.url;


    router.events.subscribe((val) => {
      if(location.path() != ''){
        this.websiteBaseUrl = location.path();
      } else {
        this.websiteBaseUrl = 'Home'
      }
    });

    console.log(this.websiteBaseUrl);

  }

  ngOnInit() {
  }

  goHome() {
    this.router.navigateByUrl('/');
  }

  showAllPAIA() {
    return this.showAllPAIADocuments = !this.showAllPAIADocuments;
  }

  showPAIA() {
    window.open('https://blouberg-physio.herokuapp.com/assets/documents/PAIA_manual.docx', '_blank');
  }

  showRequestAndFeesPayable() {
    window.open('https://blouberg-physio.herokuapp.com/assets/documents/Outcomeofrequestandfeespayable.pdf', '_blank');
  }

  showRequestAccessToRecord() {
    window.open('https://blouberg-physio.herokuapp.com/assets/documents/Requestforaccesstorecord.pdf', '_blank')
  }

  showRequestGuideCopy() {
    window.open('https://blouberg-physio.herokuapp.com/assets/documents/Requestforcopyofguide.pdf', '_blank')
  }


  showPracticePolicy() {
    window.open('https://blouberg-physio.herokuapp.com/assets/documents/Practice_Policy.docx', '_blank');
  }

  showPracticePrivacy() {
    window.open('https://blouberg-physio.herokuapp.com/assets/documents/Practice_privacy_statement.docx', '_blank');
  }

  showRequestFormForAccess() {
    window.open('https://blouberg-physio.herokuapp.com/assets/documents/RequestformforaccesstoPAIAmanual.pdf', '_blank');
  }

  showWebsite() {
    window.open('https://blouberg-physio.herokuapp.com/assets/documents/Website_T+Cs.docx', '_blank');
  }

}
